import { addStyles } from 'ethcss'
import 'blocks.app/loader/loader.css'
import { colors, IStyles, mediaCSS } from 'theme'

const styles: IStyles = {
    modalWrapper: {
        position: 'fixed',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        backgroundColor: 'rgba(0,0,0, 0.7)',
    },
    modalInner: {
        position: 'absolute',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        height: '98%',
        width: 640,
        backgroundColor: colors.white,
        borderRadius: 20,
        padding: 30,

        [mediaCSS.tabMini]: {
            width: '96%',
            padding: 10,
        },
    },
    title: {
        fontSize: 22,
        marginBottom: 12,

        [mediaCSS.tabMini]: {
            fontSize: 18,
        },
    },
    desc: {
        fontSize: 16,
        marginBottom: 24,

        [mediaCSS.tabMini]: {
            fontSize: 12,
        },
    },
    search: {
        position: 'relative',
        marginBottom: 16,
    },
    inputActionBtn: {
        position: 'absolute',
        right: 12,
        top: '50%',
        transform: 'translateY(-50%)',
    },
    channelListCaption: {
        padding: '10px 12px',
        backgroundColor: colors.greyLight,
        fontWeight: 'bold',
        borderRadius: '5px 5px 0 0',
    },
    channelItem: {
        position: 'relative',
        padding: '10px 12px',
        border: '1px solid ' + colors.greyLight,
        cursor: 'pointer',
        backgroundColor: colors.white,

        '&:hover': {
            backgroundColor: colors.greyLight,
        },
    },
    channelItemPlaying: {
        fontWeight: 600,
    },
    play: {
        position: 'absolute',
        right: 12,
        top: '50%',
        transform: 'translateY(-50%)',
    },
    viewMode: {
        marginBottom: 24,
    },
    viewModeTitle: {
        marginBottom: 12,
    },
    viewModeRadioWrapper: {
        display: 'flex',
    },
    radio: {
        marginRight: 40,
    },
    closeButtonWrapper: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: 32,

        [mediaCSS.tabMini]: {
            position: 'absolute',
            bottom: 10,
            left: '50%',
            transform: 'translateX(-50%)',
        },
    },
    channelList: {
        height: 'calc(100% - 150px)',
    },
    channelListMulti: {
        height: 'calc(100% - 276px)',
    },
    listWrapper: {
        position: 'relative',
        height: 'calc(100% - 34px)',
        overflow: 'auto',
    },
    noChannels: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
    },
}

addStyles(styles)
export default styles
